const PrimaryButtonTimeline = () => {
  const components = document.querySelectorAll('[data-component-primary-button]');
  components.forEach((component) => {
    const timeline = gsap.timeline({paused: true});
    setupComponentScrollTrigger(component, timeline);
  });
};

PrimaryButtonTimeline();